import axios from "axios";
import React, { useEffect, useState } from "react";

const ImageViewModal = ({ isOpen = false, onClose = () => {}, url }) => {
  const [imageSrc, setImageSrc] = useState("");

  const fetchImage = async () => {
    try {
      const response = await axios.get(url, { responseType: "blob" });
      const imageUrl = URL.createObjectURL(response.data);
      setImageSrc(imageUrl);
    } catch (error) {
      console.error("Error loading image", error);
    }
  };

  useEffect(() => {
    if (isOpen && url) {
      fetchImage();
    }

    return () => {
      if (imageSrc) {
        URL.revokeObjectURL(imageSrc); // clean up
        setImageSrc("");
      }
    };
  }, [isOpen, url]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-10 flex items-center justify-center"
          onClick={handleOverlayClick}
        >
          <div
            className="bg-white rounded-lg shadow-lg max-w-lg w-full p-2 relative"
            onClick={(e) => e.stopPropagation()}
          >
            {imageSrc ? (
              <img
                src={imageSrc}
                alt="Preview"
                className="w-full h-auto rounded-md"
              />
            ) : (
              <div className="text-center text-gray-500">Loading image...</div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ImageViewModal;
